export const REACT_APP_BFF_NODE = process.env['REACT_APP_BFF_NODE']
export const REACT_APP_BFF_IMAGE = process.env['REACT_APP_BFF_IMAGE']
